import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { sendContactRequest } from "../../apis/contactApi";
import { errorToast, successToast } from "../tost";
import LoaderModal from "./modal-loader";

const RequestDemoModal = ({ isOpen, closeModal }) => {
    const [loading, setloading] = useState(false)
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [isOpen]);

    const validationSchema = Yup.object({
        name: Yup.string().required("Name is required"),
        email: Yup.string()
            .email("Invalid email address")
            .required("Email is required"),
        mobile: Yup.string()
            .matches(/^\d{10}$/, "Phone number must be 10 digits")
            .required("Phone number is required"),
        message: Yup.string().required("Message is required"), // New message validation
    });

    const initialValues = {
        name: "",
        email: "",
        mobile: "",
        message: "",
        type: "Demo"
    };

    const handleSubmit = async (values, { resetForm }) => {
        setloading(true);
        try {
            const response = await sendContactRequest(values);

            if (response?.status === 200) {
                successToast("Request sent successfully!");
            } else {
                const errorMessage = response?.data?.message || "Something went wrong!";
                errorToast(errorMessage);
            }
        } catch (error) {
            console.error("Error occurred:", error);
            errorToast(error?.response?.data?.message || "Failed to submit request. Please try later.");
        } finally {
            setloading(false);
            resetForm();
            closeModal()
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl xl:max-w-3xl">
                <h2 className="text-xl font-bold text-navy mb-4 text-center">Contact Us</h2>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    <Form className="flex flex-col items-center">
                        <div className="mb-4 w-full">
                            <label className="block text-sm font-medium text-gray-700">
                                Name
                            </label>
                            <Field
                                name="name"
                                type="text"
                                className="input-field w-full"
                                placeholder="Enter your name"
                            />
                            <ErrorMessage
                                name="name"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                            />
                        </div>
                        <div className="mb-4 w-full">
                            <label className="block text-sm font-medium text-gray-700">
                                Email
                            </label>
                            <Field
                                name="email"
                                type="email"
                                className="input-field w-full"
                                placeholder="Enter your email"
                            />
                            <ErrorMessage
                                name="email"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                            />
                        </div>
                        <div className="mb-4 w-full">
                            <label className="block text-sm font-medium text-gray-700">
                                Phone
                            </label>
                            <Field
                                name="mobile"
                                type="text"
                                className="input-field w-full"
                                placeholder="Enter your mobile number"
                            />
                            <ErrorMessage
                                name="mobile"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                            />
                        </div>
                        <div className="mb-4 w-full">
                            <label className="block text-sm font-medium text-gray-700">
                                Message
                            </label>
                            <Field
                                as="textarea"
                                name="message"
                                className="input-field w-full h-24 resize-none"
                                placeholder="Enter your message"
                            />
                            <ErrorMessage
                                name="message"
                                component="div"
                                className="text-red-500 text-sm mt-1"
                            />
                        </div>
                        <div className="flex flex-col sm:flex-row justify-between space-y-4 sm:space-y-0 sm:space-x-4 w-full">
                            <button
                                type="button"
                                onClick={closeModal}
                                className="bg-gray-300 text-navy px-4 py-2 rounded hover:bg-gray-400 w-full sm:w-auto"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 w-full sm:w-auto"
                            >
                                Submit
                            </button>
                        </div>
                    </Form>
                </Formik>
                {loading && <LoaderModal />}
            </div>
        </div>
    );
};

export default RequestDemoModal;


